module.exports = __webpack_public_path__ + "img/purple-3-diamond-solid.2292c37a.svg";